module.exports = __webpack_public_path__ + "img/laptop-basics.e342eac6.png";